import { useState, useEffect, useRef } from 'react';

const SIGNUPS = [
  { name: 'Alex', location: 'KLAX' },
  { name: 'Marcus', location: 'KJFK' },
  { name: 'Sarah', location: 'KORD' },
  { name: 'Tyler', location: 'KDFW' },
  { name: 'Jordan', location: 'KSFO' },
  { name: 'Priya', location: 'KATL' },
  { name: 'Ethan', location: 'KDEN' },
  { name: 'Chloe', location: 'KMIA' },
  { name: 'Nate', location: 'KBOS' },
  { name: 'Leila', location: 'KSEA' },
  { name: 'Ryan', location: 'KPHX' },
  { name: 'Mia', location: 'KLAS' },
  { name: 'Owen', location: 'KIAH' },
  { name: 'Zoe', location: 'KMSP' },
  { name: 'Derek', location: 'KPHL' },
  { name: 'Aisha', location: 'KDTW' },
  { name: 'Caleb', location: 'KSLC' },
  { name: 'Nina', location: 'KBWI' },
  { name: 'Finn', location: 'KPDX' },
  { name: 'Hana', location: 'HNLK' },
];

const TIMES = ['just now', '1 min ago', '2 min ago', '3 min ago', '5 min ago'];

function randomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}

interface TickerItem {
  id: number;
  name: string;
  location: string;
  time: string;
}

let idCounter = 0;

function generateItem(): TickerItem {
  const signup = randomItem(SIGNUPS);
  return {
    id: ++idCounter,
    name: signup.name,
    location: signup.location,
    time: randomItem(TIMES),
  };
}

export default function SocialProofTicker() {
  const [items, setItems] = useState<TickerItem[]>(() =>
    Array.from({ length: 12 }, generateItem)
  );
  const trackRef = useRef<HTMLDivElement>(null);

  // Periodically inject a new item at the front
  useEffect(() => {
    const interval = setInterval(() => {
      setItems((prev) => [generateItem(), ...prev.slice(0, 19)]);
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  // Duplicate items for seamless infinite scroll
  const displayed = [...items, ...items];

  return (
    <div className="w-full overflow-hidden bg-[#0D1E35] border-y border-white/5 py-3 relative">
      {/* Left fade */}
      <div className="absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-[#0D1E35] to-transparent z-10 pointer-events-none" />
      {/* Right fade */}
      <div className="absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-[#0D1E35] to-transparent z-10 pointer-events-none" />

      <div
        ref={trackRef}
        className="flex gap-6 animate-ticker whitespace-nowrap"
        style={{ width: 'max-content' }}
      >
        {displayed.map((item, idx) => (
          <div
            key={`${item.id}-${idx}`}
            className="flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-4 py-1.5 text-sm shrink-0"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-user-smile-line text-[#00FFD1] text-xs" />
            </span>
            <span className="text-white/90 font-medium">{item.name}</span>
            <span className="text-white/40">from</span>
            <span className="text-[#00FFD1] font-semibold tracking-wide">{item.location}</span>
            <span className="text-white/30">·</span>
            <span className="text-white/40 text-xs">{item.time}</span>
            <span className="text-white/30">·</span>
            <span className="text-white/50 text-xs">just joined</span>
          </div>
        ))}
      </div>
    </div>
  );
}
